"use strict";

// from: https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/before()/before().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('before')) {
      return;
    }
    Object.defineProperty(item, 'before', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function before() {
        var argArr = Array.prototype.slice.call(arguments),
          docFrag = document.createDocumentFragment();

        argArr.forEach(function (argItem) {
          var isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });

        this.parentNode.insertBefore(docFrag, this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// Navtoggler
document.querySelector('.headerbar__navtoggler').addEventListener('click', () =>  {
  if (document.body.classList.contains('body--activenav')) {
  document.body.classList.remove('body--activenav');
  } else {
    document.body.classList.add('body--activenav');
  }
});

// A11yToggler
document.querySelector('.headerbar__a11ytoggler').addEventListener('click', () =>  {
  if (document.querySelector('.headerbar__a11ynav').classList.contains('active')) {
    document.querySelector('.headerbar__a11ynav').classList.remove('active');
  } else {
    document.querySelector('.headerbar__a11ynav').classList.add('active');
  }
});

// Singleblog layout
if (document.querySelectorAll('.singleblog').length > 0) {
  let headings = {};
  let i = 0;
  let lastMainHeading = false;

  for (let heading of document.querySelectorAll('.item h2, .item h3')) {
    let jumplink = document.createElement('span');

    jumplink.setAttribute('id', 'jumpheading' + i)
    jumplink.classList.add('anchorlink')
    heading.before(jumplink);

    if (heading.tagName === 'H2') {
      lastMainHeading = i
      headings[i] = {name: heading.textContent, children: {}, hasChildren: false}
    } else {
      headings[lastMainHeading].hasChildren = true
      headings[lastMainHeading].children[i] = {name: heading.textContent}
    }

    i++
  }

  for (const id in headings) {
    let heading = headings[id]

    let childrenHtml = false

    if (heading.hasChildren) {
      childrenHtml = document.createElement('ul');

      for (const childId in heading.children) {
        let child = heading.children[childId]

        let childLink = document.createElement('a')
        childLink.setAttribute('href', '#jumpheading' + childId)
        childLink.innerHTML = child.name
        childLink.classList.add('nav-link')

        let childItem = document.createElement('li')
        childItem.appendChild(childLink)

        childrenHtml.appendChild(childItem)
      }
    }

    let headingLink = document.createElement('a')
    headingLink.setAttribute('href', '#jumpheading' + id)
    headingLink.innerHTML = heading.name
    headingLink.classList.add('nav-link')

    let headingItem = document.createElement('li')

    headingItem.appendChild(headingLink)

    if (childrenHtml) {
      headingItem.appendChild(childrenHtml)
      headingItem.classList.add('parent');
    }

    document.querySelector('.singleblog__nav ul').appendChild(headingItem)
  }
  document.querySelector('.singleblog__nav__toggler').addEventListener('click', () => {
    document.querySelector('.singleblog__nav').classList.toggle('opened');
    if (document.querySelector('.singleblog__nav').classList.contains('opened') === true) {
      document.querySelector('.singleblog__nav__toggler').innerText = 'Schließen';
    }
    if (document.querySelector('.singleblog__nav').classList.contains('opened') === false) {
      document.querySelector('.singleblog__nav__toggler').innerText = 'Seitennavigation Öffnen';
    }
  })
}

// Singleblog Layout Highlighting and Nav Behaviour

function isElementInViewport (el) {
  const rect = el.getBoundingClientRect();
  // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
  const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

  // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
  const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
  const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

  return (vertInView && horInView);
}

// once on pageload

if (document.querySelector('.singleblog__nav__itemlist a')) {
  document.querySelector('.singleblog__nav__itemlist a').classList.add('inviewport');
}

window.addEventListener('scroll', () => {
  let singleblogHeadings = document.querySelectorAll('.anchorlink');

  for (let singleblogHeading of singleblogHeadings) {
    if(isElementInViewport(singleblogHeading) === true) {
      let navitem = document.querySelector('.singleblog__nav__itemlist a[href="#' + singleblogHeading.id + '"]');

      if(navitem) {
        // Remove old active items
        for (let activeItem of document.querySelectorAll('.singleblog__nav__itemlist li a.inviewport')) {
          activeItem.classList.remove('inviewport');
        }

        navitem.classList.add('inviewport');

        if (navitem.parentNode.parentNode.parentNode.nodeName === "LI") {
          navitem.parentNode.parentNode.parentNode.firstChild.classList.add('inviewport')
        }

        return;
      }
    };
  }
})

// Detect Safari and add pageclass

window.addEventListener('DOMContentLoaded', () => {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('safari') != -1) {
    if (ua.indexOf('chrome') > -1) {

    } else {
      document.body.classList.add('isSafari');
    }
  }
})

window.addEventListener('scroll', () => {
  if (document.body.classList.contains('isSafari') === true && document.querySelectorAll('.singleblog') != null) {
    if (window.scrollY > 180) {
      document.querySelector('.singleblog__nav').style.transform = "translateY(0rem)";
    } else {
      document.querySelector('.singleblog__nav').style.transform = "translateY(0rem)";
    }
  }
})

// Add behaviour for showchildrenblog

if (document.querySelectorAll('.showchildrenblog').length > 0) {
  let itemrows = document.querySelectorAll('.showchildrenblog .row');
  let rowcount = 2;

  updateRowcount();
  checkForItems();

  document.querySelector('.btn-addarticles').addEventListener('click', () => {
    rowcount = rowcount + 2;
    checkForItems();
    updateRowcount();
  })

  function checkForItems() {
    if (rowcount >= itemrows.length) {
      console.log(rowcount, itemrows.length)
      document.querySelector('.btn-addarticles').style.display = 'none';
    }
  }

  function updateRowcount() {
    for (var i = 0; i < rowcount; i++) {
      itemrows[i].style.display = 'flex';
      itemrows[i].style.display = '-ms-flexbox';
    }
  }
}

// Menu Workflow for Phones and Tablets (Offcanvas)

if(window.outerWidth < 992) {
  let parentMenuItemsNodelist = document.querySelectorAll('.headerbar__mainnav ul li.parent.deeper > a');
  let parentMenuItems = Array.from(parentMenuItemsNodelist); // Need to convert to Array


  parentMenuItems.forEach(function(parentMenuItem) {

    parentMenuItem.addEventListener('click',function (e) {

      let MenuItemSubnav = getSiblings(this); // child ul of clicked list-item
      let ParentMenuItemSiblings = getSiblings(this.parentNode); // siblings of click list-item

      if(this.classList.contains('clicked')) {
      }
      else {
        e.preventDefault();
        this.classList.add('clicked');
        MenuItemSubnav[0].classList.add('expanded');
      }
    })
  });
}

// Keyboard navigation
let resetMainnavA11y = function() {
  for (let submenu of document.querySelectorAll('.shownav')) {
    submenu.setAttribute('aria-hidden', 'true')
    submenu.classList.remove('shownav')

    for (let sublink of submenu.querySelectorAll('a')) {
      sublink.setAttribute('tabIndex', -1)
    }
  }
}

var parentLinks = document.querySelectorAll('.headerbar__mainnav > ul li.parent > a');

// Set tabIndex to -1 so that parent_links can't receive focus until menu is open
for (let parentLink of parentLinks) {
  for (let subLink of parentLink.querySelectorAll('a'))
  {
    subLink.setAttribute('tabIndex', -1);
  }
}

for (let link of document.querySelectorAll('.headerbar__mainnav > ul li > a')) {
  link.addEventListener('hover', function (e) {
    e.currentTarget.parentNode.parentNode.setAttribute('aria-hidden', 'false')

    for (let ulitem of e.currentTarget.parentNode.parentNode.querySelectorAll('.shownav')) {
      ulitem.setAttribute('aria-hidden', 'true')
      ulitem.classList.remove('shownav')
      for (let navitem of ulitem.querySelectorAll('a'))
      {
        navitem.setAttribute('tabIndex', -1);
      }
    }

    if (e.currentTarget.nextElementSibling) {
      e.currentTarget.nextElementSibling.setAttribute('aria-hidden', 'false')
      e.currentTarget.nextElementSibling.classList.add('shownav')

      for (let navitem of e.currentTarget.nextElementSibling.querySelectorAll('a'))
      {
        navitem.setAttribute('tabIndex', 0);
      }
    }
  })

  link.addEventListener('focus', function (e) {
    for (let ulitem of e.currentTarget.parentNode.parentNode.querySelectorAll('.shownav')) {
      ulitem.setAttribute('aria-hidden', 'true')
      ulitem.classList.remove('shownav')
      for (let navitem of ulitem.querySelectorAll('a'))
      {
        navitem.setAttribute('tabIndex', -1);
      }
    }

    if (e.currentTarget.nextElementSibling) {
      e.currentTarget.nextElementSibling.setAttribute('aria-hidden', 'false')
      e.currentTarget.nextElementSibling.classList.add('shownav')

      for (let navitem of e.currentTarget.nextElementSibling.querySelectorAll('a'))
      {
        navitem.setAttribute('tabIndex', 0);
      }
    }
  })
}



// Hide menu if click or focus occurs outside of navigation
document.querySelectorAll('.headerbar__mainnav > ul a')[document.querySelectorAll('.headerbar__mainnav > ul a').length - 1].addEventListener('keydown', function(e) {
  if (e.keyCode === 9) {
    // If the user tabs out of the navigation hide all menus
    resetMainnavA11y()
  }
})

document.addEventListener('click', resetMainnavA11y);

document.querySelector('.headerbar__mainnav > ul').addEventListener('mouseleave', function() {
  window.navmouseleavetimeout = setTimeout(resetMainnavA11y, 1200);
});

document.querySelector('.headerbar__mainnav > ul').addEventListener('mouseenter', function() {
  clearTimeout(window.navmouseleavetimeout);
});

document.querySelector('.headerbar__mainnav > ul').click(function(e) {
  e.stopPropagation();
});


let getSiblings = function (elem) {
  let siblings = [];
  let sibling = elem.parentNode.firstChild;
  for (; sibling; sibling = sibling.nextSibling) {
    if (sibling.nodeType !== 1 || sibling === elem) continue;
    siblings.push(sibling);
  }
  return siblings;
};

// Set Pageclass if User is Logged in and Singleblog View is active
function checkForRegisteredSingleblog() {
  if(document.querySelector('.breadcrumbs .mod_logout') != null && document.querySelector('.singleblog') != null) {
    document.body.classList.add('singleblog--registered-user');
  }
}
checkForRegisteredSingleblog();

// Internet Explorer Detection

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

if (isIE11) {
  document.body.classList.add('isIE');
}

if (document.getElementById('system-message')) {
  window.setTimeout( () => {
    window.scrollTo(0, document.getElementById('system-message').offsetTop - 200)
  }, 750)
}


// Fix Singleblog height if Footer in View

function isVisible (ele) {
  const { top, bottom } = ele.getBoundingClientRect();
  const vHeight = (window.innerHeight || document.documentElement.clientHeight);

  return (
    (top > 0 || bottom > 0) &&
    top < vHeight
  );
}

if(window.outerWidth > 992 && document.querySelector('.singleblog__nav') != null) {
  window.addEventListener('scroll', () => {
    if (isVisible(document.querySelector('footer'))) {
      document.querySelector('.singleblog__nav').style.maxHeight = window.innerHeight - 600 + "px";
      document.querySelector('.singleblog__nav__itemlist').style.maxHeight = window.innerHeight - 600 + "px";
    } else {
      document.querySelector('.singleblog__nav').style.maxHeight = window.innerHeight - 200 + "px";
      document.querySelector('.singleblog__nav__itemlist').style.maxHeight = window.innerHeight - 200 + "px";
    }
  });
}

let currentFontSize = parseInt(localStorage.getItem('currentFontSize'), 10) || 16;

document.querySelector('.textsizetoggler--increase').addEventListener('click', () => {
  // Return if currentFontSite is larg enough
  if(currentFontSize >= 21) {
    return;
  }
  // Set Styles and Value for Local Storage
  currentFontSize++;
  updateFontSize();
  updateA11YTogglersize();
});

document.querySelector('.textsizetoggler--decrease').addEventListener('click',() => {

  if(currentFontSize <= 8) {
    return;
  }
  currentFontSize--;
  updateFontSize();
  updateA11YTogglersize();
});

let updateFontSize = function () {
  document.querySelector('html').style.fontSize = currentFontSize + 'px';
  localStorage.setItem('currentFontSize', currentFontSize.toString());
};

window.addEventListener('DOMContentLoaded', updateFontSize);

// Set size for a11y-toggler

let updateA11YTogglersize = function () {
  let a11ytextwidth = document.querySelector('.headerbar__a11ytoggler > span').offsetWidth + 16;
  document.querySelector('.headerbar__a11ytoggler').style.width = 'calc(2rem + ' + a11ytextwidth + 'px)';
};

window.addEventListener('DOMContentLoaded', function () {
  setTimeout(updateA11YTogglersize, 200);
});

// Add Modal functionality for a11ytogglers

for (let a11yfunctiontoggler of document.querySelectorAll('.headerbar__a11ynav .a11ytoggler')) {
  if (a11yfunctiontoggler.classList.contains('a11ytoggler--gebaerden')) {
    a11yfunctiontoggler.addEventListener('click', () => {
      document.querySelector('.a11yarea--gebaerdensprache').classList.add('active');
      document.querySelector('.a11yarea--gebaerdensprache > *').focus();
    });
  }
}

let closea11yarea = function () {
  for (let activea11yarea of document.querySelectorAll('.a11yarea.active')) {
    activea11yarea.classList.remove('active');
    document.querySelector('.toolbar nav').focus();
  }
}

for (let a11yareabg of document.querySelectorAll('.a11yareabg, .a11yarea__toggler' )) {
  a11yareabg.addEventListener('click', closea11yarea);
}

window.addEventListener('DOMContentLoaded', function () {
	setTimeout(() => {
		let highlightedSpan = document.querySelector('.singleblog__content span.highlight')

		if (!highlightedSpan) {
			return
		}
console.log(highlightedSpan)
		highlightedSpan.scrollIntoView()
	}, 100);
});
